import { Star } from 'lucide-react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';

const reviews = [
  {
    name: 'Sarah K.',
    comment:
      'Game-changer for my Instagram strategy! The insights provided are invaluable for growing my account and engaging with my followers effectively.',
  },
  {
    name: 'Mike T.',
    comment:
      "Always up-to-date and intuitive. I've tried many tools, but this one stands out for its accuracy and ease of use. Highly recommended for any serious Instagram user.",
  },
  {
    name: 'Emma R.',
    comment:
      'Helps me understand my audience better. The detailed analytics have allowed me to tailor my content strategy and see real growth in my engagement rates.',
  },
  {
    name: 'John D.',
    comment:
      "Essential tool for our marketing team. We've been able to track our campaign performance more accurately and adjust our strategies in real-time.",
  },
  {
    name: 'Lisa M.',
    comment:
      'Accurate insights, easy to use. I appreciate how user-friendly the interface is, making it simple to get the data I need without any hassle.',
  },
  {
    name: 'Alex P.',
    comment:
      "Boosted our engagement significantly. Since using this tool, we've seen a 30% increase in our follower interaction. It's been a game-changer for our brand.",
  },
];

export default function UserReviewsSection() {
  const { t } = useTranslation();

  return (
    <section className={styles['user-reviews-section']}>
      <h2 className={styles.title}>{t("Review about Dolphinradar's Free recent follow tool")}</h2>
      <div className={styles['reviews-grid']}>
        {reviews.slice(0, 3).map((review, index) => (
          <div key={index} className={styles['review-card']}>
            <div>
              <div className={styles.stars}>
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className={styles.star} />
                ))}
              </div>
              <p className={styles['review-text']}>"{t(review.comment)}"</p>
            </div>
            <p className={styles['reviewer-name']}>- {review.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
